<template>
  <!-- 一拖2 -->
  <div class="meeting-list">
    <div class="meeting-list-meeting-item">
      <div class="meeting-list-meeting-item-item">
        <div class="meeting-list-meeting-item-item-type">
          <img src="/static/v4/icon_list_tag_column.svg" alt="" />
        </div>
        <img :src="dataItem.cover_img" alt="" class="meeting-list-meeting-item-item-subject" />
      </div>
    </div>

    <div class="meeting-list-conference-content" v-if="dataItem.items && dataItem.items.length > 0">
      <div class="meeting-list-conference-content-left" v-for="childItem in dataItem.items" :key="childItem.id"
        @click.stop="goDetails(childItem)">
        <div class="meeting-list-conference-content-left-header">
          <img :src="childItem.cover_img" alt="" />
          <img src="/static/img/live/icon_list_tag_live_history.svg" alt="" />
          <!--                        <div class="meeting-list-conference-content-left-header-date">{{ childItem.duration_format }}</div>-->
        </div>
        <div class="meeting-list-conference-content-left-title">
          <div class="title_style">{{ childItem.title  }}</div>
          <div>{{ childItem.view_count }}人观看</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Interface from '@/util/interface.js'
  export default {
    props: {
      dataItem: {
        type: Object
      }
    },

    methods: {
      goDetails(row) {
        Interface.goLiveDetail(this, row)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .meeting-list {
    margin: 10px 10px;
    background: #ffffff;
    border-radius: 8px;
    padding: 12px;

    &-meeting-item {
      width: 331px;
      height: 186px;
      border-radius: 8px;

      &-item {
        position: relative;
        width: 331px;
        height: 185px;
        background: #eff3fa;
        border-radius: 8px;

        &-type {
          position: absolute;
          left: 1px;
          top: 1px;
          height: 18px;
          border-radius: 6px 2px 6px 2px;
          display: flex;
          align-items: center;

          span {
            padding: 0px 5px;
            line-height: 18px;
            font-size: 10px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #ffffff;
            line-height: 14px;
          }
        }

        &-subject {
          width: 331px;
          height: 185px;
          border-radius: 6px;
        }

        &-template-title-log,
        &-template-box {
          position: absolute;
          height: 50px;
          top: 115px;
          left: 0px;
          width: 330px;
          height: 70px;
          background: linear-gradient(180deg, rgba(34, 34, 34, 0) 0%, rgba(0, 0, 0, 0.2) 40%, rgba(0, 0, 0, 0.5) 100%);
          border-radius: 6px;

          .meeting-list-meeting-item-item-template-title {
            font-size: 17px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 500;
            color: #ffffff;
            line-height: 24px;
            margin-bottom: 10px;
            padding-left: 14px;
            padding-right: 20px;
          }

          .meeting-list-meeting-item-item-template-date {
            font-size: 13px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #ffffff;
            line-height: 18px;
            padding-left: 14px;
          }
        }

        &-template-title-log {
          position: absolute;
          height: 80px;
          top: 105px;
          left: 0px;
          width: 330px;
          background: linear-gradient(180deg, rgba(34, 34, 34, 0) 0%, rgba(0, 0, 0, 0.2) 40%, rgba(0, 0, 0, 0.5) 100%);
          border-radius: 6px;
        }
      }
    }

    &-conference {
      width: 355px;
      height: 231px;
      background: #ffffff;
      border-radius: 8px;
      padding-top: 1px;
      box-sizing: border-box;

      &-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-left: 15px;
        margin-right: 10px;
        margin-top: 16px;
        margin-bottom: 16px;

        span {
          &:nth-child(1) {
            font-size: 18px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #222222;
            line-height: 25px;
          }

          &:nth-child(2) {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #adadaf;
            line-height: 20px;
          }
        }
      }

      &-content {
        display: flex;
        justify-content: space-between;
        box-sizing: border-box;

        &-left {
          padding-right: 12px;
          text-align: left;
        }

        &-right,
        &-left {
          position: relative;

          &-header {
            position: relative;

            img {
              &:nth-child(1) {
                width: 160px;
                height: 90px;
                border-radius: 6px;
              }

              &:nth-child(2) {
                position: absolute;
                left: 0px;
                top: 0px;
                height: 18px;
                border-radius: 6px 2px 6px 2px;
              }
            }

            &-date {
              position: absolute;
              bottom: 0px;
              right: 0px;
              font-size: 12px;
              margin-right: 6px;
              margin-bottom: 4px;
              font-family: Avenir-Heavy, Avenir;
              font-weight: 800;
              color: #ffffff;
              line-height: 16px;
            }
          }

          &-title {
            width: 156px;
            padding-left: 5px;
            box-sizing: border-box;              height: calc(100% - 90px);
            display: flex;              flex-direction: column;             justify-content: space-between;

            div {
              &:nth-child(1) {
                font-size: 14px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #222222;
                line-height: 18px;
                padding: 9px 0px 0px 0px;
              }

              &:nth-child(2) {
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #979797;
                line-height: 17px;
                margin-top: 8px;
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/live/list/live-column.vue